<div >
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
    
    <app-admin-navigation
        [params]="{page: 'DOMAINS'}" [type]="'SELF_REPORT'">
    </app-admin-navigation>


    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header__title">
                    {{ 'Domains Management' | translate }}
                </div>
                <div class="card--box__header--action text-xs-right">
                    <span class="card--box__header__action float-xs-right" *ngIf="isCreatable">
                        <button type="button" class="btn btn-link  card--box__header__action__button" (click)="exportDomain($event)">
                            <i class="fas fa-download"></i>
                            <span class="hidden-sm-down">{{ 'Retrieve Data' | translate}}</span>
                        </button>
                    </span>
                    <span class="card--box__header__action float-xs-right">
                        <button type="button" class="btn btn-link  card--box__header__action__button" (click)="openFormModal({action: 'create', title: 'Add Domain', url: '/domains'});">
                            <i class="fas fa-plus-circle"></i>
                            <span class="hidden-sm-down">{{ 'Add Domain' | translate}}</span>
                        </button>
                    </span>
                </div>
            </div>

            <div class="card-block card--box__block">
                <div class="row">
                    <!--search filters-->
                    <div class="offset-xs-10 col-xs-2">
                        <select class="form-control" (change)="itemLanguage = $event.target.value">
                            <option *ngFor="let language of languages"
                                    [selected]="language['locale'] === itemLanguage"
                                    [value]="language['locale']">
                                {{ language.name | translate }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid">
            <div class="table--grid__body">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }} header">
                                <span>
                                    {{ column[1] | translate }} <span *ngIf="column[3] === 'name'">{{ itemLanguage }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!--table cells-->
                <ng-container *ngFor="let domain of items">
                    <div class="row parent" *ngIf="checkParent(domain)"  (click)="openFormModal({action: 'read', id: domain['parent']['id'], title: 'Domain Details', url: 'domains'});">
                        <div class="col-xs-12">
                            {{ domain['parent']['name_' + itemLanguage] }}
                        </div>
                    </div>

                    <div class="row" [class.inactive]="domain.deleted_at !== null">
                        <!--group header button for table-->
                        <div class="col-xs-12" (click)="openFormModal({ action: 'read', id: domain['id'], title: 'Domain Details', activated: domain['activated'], content: domain['activated'] ? 'Are you sure you want to deactivate this domain?' : 'Are you sure you want to activate this domain?', description: domain['name'], url: '/domains' });">
                            <div class="row">
                                <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                    <ng-template [ngIf]="column[3] !== 'name'" [ngIfElse]="isTranslateColumn">
                                        <ng-template [ngIf]="column[4] === 'boolean'">
                                            {{ (domain[column[0]] === 0 ? 'No' : 'Yes') | translate}}
                                        </ng-template>
                                        <ng-template [ngIf]="column[4] !== 'boolean'">
                                            {{ domain[column[0]] }}
                                        </ng-template>
                                    </ng-template>
                                    <ng-template #isTranslateColumn>
                                        {{ domain[column[0] + itemLanguage] | translate }}
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-3 table--grid__actions table--grid__actions--hover">
                            <div class="btn-group dropdown" dropdown>
                                <button class="btn btn-link table--grid__actions__ellipsis dropdown-toggle" dropdownToggle>
                                    <i class="fas fa-ellipsis-h table--grid__actions__ellipsis__icon"
                                       aria-hidden="true"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right table--grid__actions__links">
                                    <li class="dropdown-item" (click)="openFormModal({action: 'update', id: domain['id'], title: 'Update Domain', url: 'domains'});">
                                        <a class="btn btn-link table--grid__action-btn">
                                            <i class="fas fa-pencil-alt table--grid__actions__links__icon" aria-hidden="true"
                                               title="{{ 'Edit' | translate }}"
                                               attr.name="{{ 'Edit' | translate }}"></i>
                                        </a>
                                    </li>
                                    <li class="dropdown-item" (click)="delete(domain)">
                                        <a class="btn btn-link table--grid__action-btn">
                                            <i class="far fa-trash-alt table--grid__actions__links__icon"
                                               title="{{ 'Delete' | translate }}"
                                               attr.name="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden"
                          [(page)]="currentPage"
                          [total]="totalItems"
                          [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)" #pagination>

    </pagination-component>
    <div class="mt-1 mb-1"></div>
    <!-- Modal -->
    <div bsModal #modal="bs-modal" class="modal fade modal-confirm-domain" [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''" tabindex="-1" role="dialog" aria-hidden="true">

        <div class="modal-dialog">
            <domains-modal-component
                [domains]="items"
                [params]="params"
                [itemLanguage]="itemLanguage"
                [formLoading]="formLoading"
                [form]="form"
                [formSubmitted]="formSubmitted"
                [languages]="languages"
                [authService]="authService"
                [token]="token"
                [helpRawData]="helpDomainProfile"
                (hideModal)="hideModal()"
                (submit)="submit(form.value, form.valid, url, true)"
                (openFormModal)="openFormModal({ action: 'update', id: params['id'], title: 'Update Domain', url: 'domains' })"
                (delete)="delete(params)"
                >
            </domains-modal-component>
        </div>
    </div>
    <!--close <div bsModal ...-->

    <div bsModal #modalDeleteDomain="bs-modal" class="modal fade modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-confirmation-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body text-xs-center">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="modal-icon">
                                <i class="far fa-trash-alt" ng-class="icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 modal-title">
                            {{ 'Delete domain confirmation' | translate }}
                        </div>
                        <div class="col-xs-12 modal-content">
                            {{ 'Are you sure you want to delete this domain?' | translate }}
                            <br/>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary " (click)="this.modalDeleteDomain.hide()">
                                <i class="fas fa-ban"></i>
                                {{ 'Cancel' | translate }}
                            </button>
                            <button type="button" class="btn btn-primary " (click)="submitDelete()">
                                <i class="fas fa-check"></i>
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<dialog-component #dialog></dialog-component>
<dialog-component #dialogLogo></dialog-component>
